module.exports = __webpack_public_path__ + "img/lanse-au-loup-sunrise-rsmith-20211230_082857.174edc2a.jpg";